export const TENANT_SYSTEM_ROLES = Object.freeze({
  OWNER: 'owner',
  MANAGER: 'manager',
  CASHIER: 'cashier',
  KITCHEN: 'kitchen',
});

export const TENANT_SYSTEM_ROLE_NAMES = Object.freeze({
  owner: 'Owner',
  manager: 'Manager',
  cashier: 'Cashier',
  kitchen: 'Kitchen',
});

export const ADMIN_ROLES = Object.freeze({
  SUPER_ADMIN: 'super_admin',
  SUPPORT: 'support',
  VIEWER: 'viewer',
});

export const ADMIN_ROLE_LIST = Object.values(ADMIN_ROLES);

export const ADMIN_ROLE_NAMES = Object.freeze({
  super_admin: 'Super Admin',
  support: 'Support',
  viewer: 'Viewer',
});

const ALL = ['super_admin', 'support', 'viewer'];
const STAFF = ['super_admin', 'support'];
const SUPER = ['super_admin'];

/** Admin-portal capability → admin roles that hold it. */
export const ADMIN_PERMISSIONS = Object.freeze({
  'clients.view': ALL,
  'clients.create': SUPER,
  'clients.edit': STAFF,
  'licenses.view': ALL,
  'licenses.manage': SUPER,
  'outlets.manage': STAFF,
  'devices.manage': STAFF,
  'support.actions': STAFF,
  'audit.view': ALL,
  'notes.manage': STAFF,
  'emails.view': ALL,
  'emails.resend': STAFF,
  'emails.test': SUPER,
  'plans.view': ALL,
  'plans.manage': SUPER,
  'announcements.manage': SUPER,
  'admins.manage': SUPER,
  'settings.manage': SUPER,
  // Mall / landlord sales-sharing API: only super admins create or change integrations.
  'integrations.view': STAFF,
  'integrations.manage': SUPER,
});

export function adminCan(role, permission) {
  return Boolean(ADMIN_PERMISSIONS[permission]?.includes(role));
}
